export default {"src":"/_next/static/media/ae.83872810.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};